// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import順を変えないように注意↓↓
import Vuetify, {
  VApp,
  VAlert,
  VAvatar,
  VAutocomplete,
  VBtn,
  VBtnToggle,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VChip,
  VCheckbox,
  VContainer,
  VContent,
  VDatePicker,
  VDataTable,
  VDialog,
  VDivider,
  VExpandTransition,
  VExpansionPanel,
  VExpansionPanelContent,
  VFabTransition,
  VFlex,
  VFooter,
  VForm,
  VIcon,
  VHover,
  VImg,
  VLayout,
  VLabel,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
  VPagination,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VSheet,
  VSelect,
  VSnackbar,
  VSpacer,
  VStepper,
  VStepperHeader,
  VStepperStep,
  VSubheader,
  VSwitch,
  VTab,
  VTabsItems,
  VTabItem,
  VTabs,
  VTextarea,
  VTextField,
  VTreeview,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
  VTooltip,
  VWindow,
  VWindowItem,
  VBreadcrumbs,
  VListTileContent,
  VListTileAction,
  VNavigationDrawer,
  VBadge,
  VCombobox,
  VParallax,
  VSlider
} from 'vuetify/lib';
import { Ripple, Scroll } from 'vuetify/lib/directives';
import 'vuetify/dist/vuetify.min.css';
import App from './App';
import router from './router';
import store from './store/';
import extend from './extend';
// ここまで↑↑
import VueScrollTo from 'vue-scrollto';

import { toDefault, toDateTime, toDate, toTime, toDay, toNow } from './filters/date/date.filter';
import './assets/css/base.css';
import './assets/css/new_base.css';

import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

Vue.config.productionTip = process.env.NODE_ENV !== 'local';

Vue.prototype.$cdnEndpoint = process.env.CDN_ENDPOINT;

Vue.use(Vuetify, {
  theme: {
    lemon: '#FEFFEA',
    yellow: '#ffcf4c',
    orange: '#ffa502',
    red: '#ff4757',
    night_b: '#2f3542',
    night_h: '#747d8c',
    night_6h: '#a4b0be',
    night_10h: '#f1f2f6',
    blue: '#1e90ff',
    light_blue: '#DAE5FC',
    middle_blue: '#70A1FF',
    dark_blue: '#16214D',
    light_purple: '#d7d7ff',
    white: '#FFFFFF',
    grey: '#e4e4e4',
    grey_text: '#2F3542',
    grey_text_light: '#A4B0BE',
    light_green: '#45D19B',
    // grey_box: "#A4B0BE",
    grey_back: '#F1F2F6',
    // besttmp color
    best_tmp_level_d: '#E3F4FF',
    calm_blue: '#5957C4'
  },
  components: {
    VApp,
    VAlert,
    VAvatar,
    VAutocomplete,
    VBtn,
    VBtnToggle,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VChip,
    VCheckbox,
    VContainer,
    VContent,
    VDatePicker,
    VDataTable,
    VDialog,
    VDivider,
    VExpandTransition,
    VExpansionPanel,
    VExpansionPanelContent,
    VFabTransition,
    VFlex,
    VFooter,
    VForm,
    VHover,
    VIcon,
    VImg,
    VLayout,
    VLabel,
    VList,
    VListTile,
    VListTileTitle,
    VMenu,
    VPagination,
    VProgressCircular,
    VProgressLinear,
    VRadio,
    VRadioGroup,
    VSheet,
    VSelect,
    VSnackbar,
    VSpacer,
    VStepper,
    VStepperHeader,
    VStepperStep,
    VSubheader,
    VSwitch,
    VTab,
    VTabsItems,
    VTabItem,
    VTabs,
    VTextarea,
    VTextField,
    VTreeview,
    VToolbar,
    VToolbarItems,
    VToolbarTitle,
    VTooltip,
    VWindow,
    VWindowItem,
    VBreadcrumbs,
    VListTileContent,
    VListTileAction,
    VNavigationDrawer,
    VBadge,
    VCombobox,
    VParallax,
    VSlider
  },
  directives: {
    Ripple,
    Scroll
  }
});
Vue.use(VueScrollTo);

/* 日付関連のfilter */
Vue.filter('default', toDefault);
Vue.filter('dateTime', toDateTime);
Vue.filter('date', toDate);
Vue.filter('time', toTime);
Vue.filter('day', toDay);
Vue.filter('now', toNow);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>',
  extend
});

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);



// WEBPACK FOOTER //
// ./src/main.js